import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Container } from 'reactstrap';
import * as elements from '../data/Elements';
import * as Records from '../store/Records';
import * as utility from '../data/Utility';

const createRecordHolterType = {
    description: "description",
    findings: "findings"
}

class CreateRecordHolter extends React.Component {
    constructor(props) {
        super(props);

        const disabled = utility.propCheck(props.disabled, false);
        const handleKeyDown = utility.propCheck(props.handleKeyDown, null);
        const saveButton = utility.propCheck(props.saveButton, false);
        this.state = {
            disabled: disabled,
            edited: false,
            handleKeyDown: handleKeyDown,
            saveButton: saveButton
        };

        this.handleSave = this.handleSave.bind(this);
        this.handleValue = this.handleValue.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps != null &&
            prevProps.disabled !== this.props.disabled &&
            this.props.disabled !== this.state.disabled) {
            this.setState({
                disabled: this.props.disabled
            });
        }
    }

    handleSave() {
        this.props.recordsDispatch.updateHolter();
        this.props.recordsDispatch.setRefresh( true );
        this.setState({
            edited: false
        });
    }

    handleValue(type, value) {
        const record = this.props.recordsState.record;

        switch (type) {
            case createRecordHolterType.description:
                record.description = value;
                break;
            case createRecordHolterType.findings:
                record.findings = value;
                break;
            default:
                break;
        }

        this.props.recordsDispatch.set(record);
        if (!this.state.edited) {
            this.setState({
                edited: true
            });
        }
    }

    render() {
        const disabled = this.state.disabled;
        const handleKeyDown = this.state.handleKeyDown;
        var description = null;
        var findings = null;
        var record = this.props.recordsState.record;
        const save = "Save";
        const showSaveButton = (
            this.state.edited &&
            this.state.saveButton
        );

        if (record != null) {
            description = elements.getFormGroup("Description", true, elements.getInput("descriptionInput", disabled, (e) => this.handleValue(createRecordHolterType.description, e.target.value), handleKeyDown, elements.inputTypes.text, record.description));
            findings = elements.getFormGroup("Findings", true, elements.getInput("findingsInput", disabled, (e) => this.handleValue(createRecordHolterType.findings, e.target.value), handleKeyDown, elements.inputTypes.text, record.findings));
        }

        return (
            <Container className="gap group-border" fluid>
                <h4 className="center">Holter Data</h4>
                {description}
                {findings}
                {showSaveButton && (
                    <div className="button-gap">
                        <Button className="button" onClick={this.handleSave} title={save}>{save}</Button>{' '}
                        <div className="gap" />
                    </div>
                )}
            </Container>
        );
    }
}

export default connect(
    state => ({
        recordsState: state.records
    }),
    dispatch => ({
        recordsDispatch: bindActionCreators(Records.actionCreators, dispatch)
    })
)(CreateRecordHolter);



// WEBPACK FOOTER //
// ./src/components/CreateRecordHolter.js